import { render } from "./SkuVxeTable-attr-backups.vue?vue&type=template&id=7855f77a&scoped=true"
import script from "./SkuVxeTable-attr-backups.vue?vue&type=script&lang=js"
export * from "./SkuVxeTable-attr-backups.vue?vue&type=script&lang=js"

import "./SkuVxeTable-attr-backups.vue?vue&type=style&index=0&id=7855f77a&scoped=true&lang=css"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7855f77a"]])

export default __exports__